import _ from "lodash";
import React from 'react';
import {json} from "helpers/data";

import ServerImage from "components/server-image/server-image";

interface Props<T> {
    items: T[],
    title: string,
    labelField?: string,
    imageField?: string,
    onItemClick?:(item:T) => void
}

function DetailList<T extends Record<string, any>>({items,onItemClick, title, labelField = 'name', imageField = 'logo.fullPath'}: Props<T>) {
    if (items.length <= 0 ) return  null
    return (
        <div className='app-versions'>
            <h1 className='title'>{title}</h1>
            <div className='row'>
                {
                    items.map(item => <div key={item.id} onClick={() => onItemClick?.(item)} className='col-lg-4 col-md-4 col-sm-6'>
                    <div className='app'>
                        <ServerImage className='appImg' src={_.get(item, imageField)}/>
                        <p className='info'>{json(_.get(item, labelField))}</p>
                    </div>
                </div>)
                }
            </div>
        </div>
    );
}

export default DetailList;